import { useQuery } from "@tanstack/react-query";
import { getPackage } from "./packagesApi";

export const usePackageWithId = (packageId: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: ["packages", packageId],
    queryFn: ({ signal }) => getPackage(packageId!, signal),
    enabled: packageId !== undefined,
  });

  return { data, isLoading };
};
